<template>
  <div class="box">
    <van-icon class="icon" size="100px" color="#992121" name="clear" />
    <div class="status">支付失败</div>
    <van-button @click="submit" type="primary" block class="btn">付款失败，可前往"我的订单"重新支付</van-button>
  </div>
</template>

<script>
import { reactive, toRefs, onUnmounted } from 'vue'
import { useRouter } from 'vue-router'

export default {
  setup() {
    const router = useRouter()
    const state = reactive({
      count: 0
    })
    const submit = () => {
      router.push({
        path: '/orderList',
        query: {
          status: 1,
          event: '支付失败跳转订单列表'
        }
      })
    }
    onUnmounted(() => {
      localStorage.removeItem('payAway')
    })
    return {
      ...toRefs(state),
      submit
    }
  }
}
</script>

<style lang="scss" scoped>
.box {
  padding: 0 20px;
  box-sizing: border-box;
}
.icon {
  margin-top: 20vh;
}
.status {
  font-size: 16px;
  font-weight: 600;
  color: #666666;
  margin-top: 24px;
}
.btn {
  margin-top: 20vh;
  width: 100%;
  background: #992121;
  border-color: #992121;
}
</style>
